<div class="container-fluid bg-color-main py-5">
  <div class="row d-flex align-items-center justify-content-center">
    <div class="col-10 border-radius-main bg-color-header">
      <p-accordion class="w-full">
        <p-accordionTab (click)="clicItem(0)">
          <ng-template pTemplate="header">
            <div class="d-flex col-12 align-items-center border-bottom-grey" >
              <div class="box-inside-alienation">
                <img
                  [attr.alt]="heartalt"
                  [attr.src]="heartsrc"
                  class="img-fluid"
                />
                <div class="pl-3">
                    <span class="text-header-style">Beneficios incluídos</span>
                </div>
              </div>
              <img
                [attr.alt]="dropdownalt"
                [attr.src]="getImageSrc(0)"
                class="img-fluid"
              />
            </div>
          </ng-template>
          <div class="p-style-accordion d-flex-direction">
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Servicios hospitalarios para la estabilización y tratamiento de una emergencia, incluyendo, pero sin estar limitados a:
                    </span>
                  </div>
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      • Telemedicina.
                    </span>
                  </div>
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      • Visita de médico a domicilio.
                    </span>
                  </div>
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      • Servicios de emergencia para pacientes internos y ambulatorios.
                    </span>
                  </div>
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      • Anestesia, transfusión de sangre, oxígeno.
                    </span>
                  </div>
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                     • Insumos hospitalarios, tal como yesos, vendajes, cabestrillos, etc.
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Máximo límite por persona, por período de vigencia. Límites disponibles: $50,000, $100,000 y $250,000. Los servicios sólo serán provistos hasta que cese la emergencia.
                     </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Pruebas de diagnóstico y procedimientos requeridos por una
                      emergencia
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      100%
                     </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      <span>Covid-19 – Coronavirus</span>
                      <br />
                      <span>
                        • Prueba de detección medicamente necesaria, máximo 2 pruebas. Excluye la primera prueba de detección realizada a su llegada al país de destino
                      </span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      100%
                     </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Condiciones Médicas Pre-existentes, limitado
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                        <span>
                          US $750 – para la opción  de cobertura por US $50,000
                        </span>
                        <br />
                        <span>
                          US $1,000 – para la opción de cobertura por US $100,000
                        </span>
                        <br />
                        <span>
                          US $1,500 – para la opción con límite máximo de US $250,000 
                        </span>
                      </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Medicamentos prescritos requeridos por una emergencia
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      US $750
                     </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Servicios de médicos y especialistas para el cuidado,
                      tratamiento o cirugía requerida por emergencia
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      100%
                     </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Emergencia dental
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      US $750 – para la opción de US $50,000 o más
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </p-accordionTab> 
        <p-accordionTab (click)="clicItem(1)">
          <ng-template pTemplate="header">
            <div class="d-flex col-12 align-items-center border-bottom-grey" >
              <div class="box-inside-alienation">
                <img
                  alt="Frame3133"
                  src="/assets/external/suitcase-new.svg"
                  class="img-fluid"
                  style="max-height: 38px;"
                />
                <div class="pl-3">
                    <span class="text-header-style">Asistencia no médica</span>
                </div>
              </div>
              <img
                [attr.alt]="dropdownalt"
                [attr.src]="getImageSrc(1)"
                class="img-fluid"
              />
            </div>
          </ng-template>
          <div class="p-style-accordion d-flex-direction">
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Traslado terrestre o aéreo por emergencia médica
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      US $50,000 - para la opción  de US $50,000 o más
                     </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Repatriación por emergencia médica
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      US $50,000 - para la opción de US $50,000 o más
                     </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Estadía en hotel por convalecencia prescrita resultante de una emergencia
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      US $100 diarios, máximo 10 días
                     </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Estadía en el hotel por resultado positivo de la prueba Covid-19 en el extranjero, limitado a:
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      US $100 diarios, máximo 14 días
                     </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Traslado de un acompañante por una hospitalización superior a cinco (5) días resultante de una emergencia
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      US $1,000
                     </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Estadía en hotel para un acompañante
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      US $100 diarios, máximo 10 días
                     </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Garantía de regreso (en fecha diferente a la programada,
                      incluido por Covid-19).
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      US $500 - diferencia en el costo del pasaje o penalidad impuesta
                     </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Regreso retrasado por Covid-19
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      US $300 - diferencia o penalidad impuesta por el transportista
                     </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Regreso de menores de 15 años o adultos mayores de 75 años.
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      US $5,000
                     </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Repatriación Funeraria
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      US $35,000 para la opción  de US $50,000 o más
                     </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Asistencia legal
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      US $1,500
                     </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Gastos de fianza
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      US $1,500
                     </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Servicio de remolque para vehículo alquilado
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      US $100
                     </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Viaje demorado o cancelado
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      US $300
                     </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Localización de equipaje
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Llamada de asistencia
                     </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Demora de equipaje superior a 72 horas
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      US $150
                     </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Demora de equipaje superior a 12 días
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      US $200
                     </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Pérdida definitiva de equipaje
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      US $20 por kilogramo de peso del equipaje, hasta US $1,000
                     </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Pérdida de conexión aérea
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      US $150
                     </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Pérdida de pasaporte
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      US $500 - gestión consular
                     </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Regreso por fallecimiento de familiar inmediato
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      US $500 - diferencia en el costo del pasaje o penalidad impuesta
                     </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Regreso por pérdida catastrófica en su domicilio
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      US $500 - diferencia en el costo del pasaje o penalidad impuesta
                     </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </p-accordionTab>
        <p-accordionTab (click)="clicItem(2)">
          <ng-template pTemplate="header">
            <div class="d-flex col-12 align-items-center border-bottom-grey" >
              <div class="box-inside-alienation">
                <img
                  alt="Frame3133"
                  src="/assets/external/option-circle.svg"
                  class="img-fluid"
                  style="max-height: 38px;"
                />
                <div class="pl-3">
                    <span class="text-header-style">Opcionales</span>
                </div>
              </div>
              <img
                [attr.alt]="dropdownalt"
                [attr.src]="getImageSrc(2)"
                class="img-fluid"
              />
            </div>
          </ng-template>
          <div class="p-style-accordion d-flex-direction">
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Condiciones Médicas Pre-existentes
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Servicios de asistencia médica para la estabilización de una emergencia médica resultado de una condición preexistente.
                      <br/>
                      El límite de esta cobertura será el 30% de la cobertura máxima seleccionada, sin exceder $30.000.
                     </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Práctica de Deportes
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Servicios de asistencia médica para la estabilización y tratamiento de una emergencia médica por accidente resultado de su participación en la practica de deportes.
                     </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Cancelación del Viaje
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Indemnización por la pérdida de los gastos prepagados, no
                      reembolsables, en relación con una cancelación inevitable del
                      viaje por una causa cubierta
                     </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Futura Mamá
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Servicios de asistencia médica para la estabilización de una emergencia médica por enfermedad o accidente producto de su embarazo. Límite Máximo: US $10,000
                      <br>
                      <i>Beneficio se adquiere entre las 12 y 32 semanas de embarazo y cuando la edad de la solicitante sea entre 18 y 40 años.</i>
                     </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Asistencia Mascotas
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Servicios de asistencia médica para la estabilización de una emergencia médica por enfermedad no preexistente o accidente de la mascota. Límite Máximo: US $1,000 por mascota. Máximo 3 mascotas
                      <br>
                      <i>Solo aplica para perros y gatos con edades entre 4 meses y 8 años.</i>
                     </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row py-4 mx-2 border-bottom-grey">
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Asistencia presencial Legal VIP
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex align-items-center">
                <div class="row px-2">
                  <div class="col-12 px-3">
                    <span class="body-text-main">
                      Asistencia presencial legal durante su viaje con apoyo local.
                     </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </p-accordionTab>
        <p-accordionTab>
          <ng-template pTemplate="header">
            <div class="d-flex col-12 align-items-center" >
              <div class="box-inside-alienation" (click)="downloadBrochure()">
                <img
                  alt="Frame3133"
                  src="/assets/external/download-svgrep.svg"
                  class="img-fluid"
                  style="max-height: 38px;"
                />
                <div class="pl-3">
                    <span class="text-header-style brochure-download">Descargar Brochure</span>
                </div>
              </div>
              <img
                [attr.alt]="dropdownalt"
                [attr.src]="getImageSrc(3)"
                class="img-fluid"
              />
            </div>
          </ng-template>          
        </p-accordionTab>    
      </p-accordion>
    </div>
  </div>  


  <div class="py-5"></div>
  <!-- <div class="row mx-0 align-center-center pt-5 justify-content-center">
    <div class="col-8 col-lg-9 col-xl-8">
      <div class="row justify-content-center">
        <div class="col-12 col-md-6 col-lg-6 col-xl-3 pb-3">
          <div class="card custom-card-middle shadow-lg custom-card-middle-blue">
            <div class="card-body p-5 align-content-center">
              <img src="/assets/img/opcionales-texto-5-1500w.png" class="rounded d-block" alt="..." height="380">
              <p class="mt-3">
                <span class="text-header-style">Mascotas</span>
              </p>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-6 col-lg-6 col-xl-3 pb-3">
            <div class="card custom-card-middle shadow-lg custom-card-middle-blue">
              <div class="card-body p-5 align-content-center">
                <img src="/assets/img/opcionales-texto-1.svg" class="rounded d-block" alt="..." height="380">
                <p class="mt-3">
                  <span class="text-header-style">Practica de Deportes</span>
                </p>
              </div>
            </div>
        </div>

        <div class="col-12 col-md-6 col-lg-6 col-xl-3 pb-3">
          <div class="card custom-card-middle shadow-lg custom-card-middle-blue">
            <div class="card-body p-5 align-content-center">
              <img src="/assets/img/opcionales-texto-3-1500w.png" class="rounded d-block" alt="..." height="380">
              <p class="mt-3">
                <span class="text-header-style">Futura Mamá</span>
              </p>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div> -->



</div>
